import './NotAccessible.scss';

function NotAccessible() {
  return (
    <div className="not-accessible">
      <div className="not-accessible__content">
        <h1>Site Unavailable</h1>
        <p>This website is not currently accessible. Please contact the site administrator.</p>
      </div>
    </div>
  );
}

export default NotAccessible;
